import React, { FC, useMemo } from 'react';
import {
    MultiSelectionEntity,
    MultiSelection as MultiSelectionModel,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { Route } from '@funtech-int/rival';

import { Carousel } from '../Carousel/Carousel';
import * as Card from '../Card';

import { SelectionTitle } from './_SelectionTitle';
import styles from './_MultiSelection.module.css';

interface MultiSelectionProps {
    selection: MultiSelectionModel;
    selectionRoute: Route<any, { id: string }, any>;
    className?: string;
    onCardShow?(item: MultiSelectionEntity, index: number): void;
    onCardClick?(item: MultiSelectionEntity, index: number): void;
}

export const MultiSelection: FC<MultiSelectionProps> = ({
    selection,
    selectionRoute,
    className,
    onCardShow,
    onCardClick,
}) => {
    const searchParams = useMemo(() => new URLSearchParams(), []);

    if (selection.showcaseId) {
        searchParams.set('selectionWindowId', selection.showcaseId);
    }

    return (
        <div className={className} data-tid="MultiSelection">
            <SelectionTitle title={selection.title} />
            <Carousel className={styles.carousel}>
                {selection.items.map((item, index) => {
                    const handleCardShow = () => {
                        onCardShow?.(item, index);
                    };

                    const handleCardClick = () => {
                        onCardClick?.(item, index);
                    };

                    return (
                        <Card.Selection
                            entity={item}
                            location={selectionRoute({ id: item.id })}
                            searchParams={searchParams}
                            onShow={handleCardShow}
                            onClick={handleCardClick}
                            key={item.id}
                        />
                    );
                })}
            </Carousel>
        </div>
    );
};
